import React from "react";
import { Card } from "@/components/ui/card";
import { Clock, CheckCircle2, XCircle, Layers } from "lucide-react";

const CARDS = [
  { key: "total", label: "Total Leads", icon: Layers, accent: "text-[#1E3A8A]", ring: "bg-blue-50" },
  { key: "pending", label: "Pending", icon: Clock, accent: "text-amber-600", ring: "bg-amber-50" },
  { key: "success", label: "Success", icon: CheckCircle2, accent: "text-emerald-600", ring: "bg-emerald-50" },
  { key: "failed", label: "Failed", icon: XCircle, accent: "text-rose-600", ring: "bg-rose-50" },
];

export default function KpiCards({ totals }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      {CARDS.map((c, i) => {
        const Icon = c.icon;
        return (
          <Card
            key={c.key}
            data-testid={`kpi-card-${c.key}`}
            className="kpi-enter p-5 border-slate-200 shadow-sm bg-white"
            style={{ animationDelay: `${i * 60}ms` }}
          >
            <div className="flex items-start justify-between">
              <div>
                <p className="text-xs font-medium text-slate-400 uppercase tracking-wider">
                  {c.label}
                </p>
                <p className={`font-mono font-bold text-3xl mt-2 ${c.accent}`}>
                  {totals?.[c.key] ?? 0}
                </p>
              </div>
              <div className={`h-10 w-10 rounded-lg ${c.ring} flex items-center justify-center`}>
                <Icon className={`h-5 w-5 ${c.accent}`} />
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
}
